import context from '@/context'
import commonErrorHandler from '@/utils/errors'
import { transformTask } from '@/utils/tasks'
import { actionCreators as myTasksActionCreators, actionTypes as myTasksTypes } from './myTasks'
import { openConfirmDialog } from '@/utils/dialogHelpers'

export const initialState = {
  changeNumber: 0,

  activeTask: null,
  activeTaskId: null,
  fetching: false,
  fetched: false,
  activating: false
}

export const actionTypes = {
  fetching: 'myActiveTask/fetching',
  fetched: 'myActiveTask/fetched',
  error: 'myActiveTask/error',

  activating: 'myActiveTask/activating',
  activated: 'myActiveTask/activated',
  deactivating: 'myActiveTask/deactivating',
  deactivated: 'myActiveTask/deactivated'
}

const handleError = (details) => commonErrorHandler(actionTypes.error, details)

export const actionCreators = {
  setActiveTask: (task) => {
    return { type: actionTypes.fetched, data: transformTask(task) || null }
  },
  getMyActiveTask: () => (dispatch) => {
    context.api.taskService.getMyActiveTask()
      .then(response => {
        dispatch(actionCreators.setActiveTask(response))
      })
      .catch(error => handleError({ dispatch, error, update: { fetching: false, fetched: true } }))
  },
  deactivateTask: () => (dispatch) => {
    dispatch({ type: actionTypes.deactivating })
    context.api.taskService.deactivateTask()
      .then(response => {
        dispatch({ type: actionTypes.deactivated })
        if (response === true) {
          dispatch({ type: actionTypes.fetched, data: null })
          dispatch(myTasksActionCreators.refresh())
        }
      })
      .catch(error => handleError({ dispatch, error, update: { activating: false } }))
  },
  activateTask: (id) => (dispatch, getState) => {
    function activateNewTask () {
      dispatch({ type: actionTypes.activating })
      context.api.taskService.activateTask(id)
        .then(response => {
          dispatch({ type: actionTypes.activated, data: id })
          dispatch(actionCreators.getMyActiveTask())
          dispatch(myTasksActionCreators.refresh())
          dispatch(myTasksActionCreators.updateStartTime({ id, startTime: response.startTime }))
        })
        .catch(error => handleError({ dispatch, error, update: { activating: false } }))
    }

    const activeTask = getState().myActiveTask.activeTask
    // Only open dialog if there is an active task
    if (!activeTask) {
      activateNewTask()
    } else {
      openConfirmDialog(
        {
          customConfirmText: 'Tasks.ChangeActiveTask',
          onAction: () => {
            activateNewTask()
          }
        })
    }
  }
}
const isIdEqual = (state, id) => state.activeTask && state.activeTask.id === id

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, fetched: true, activeTask: action.data, activeTaskId: (action.data || {}).id, changeNumber: state.changeNumber + 1 }
    case actionTypes.activating: return { ...state, activating: true }
    case actionTypes.activated: return { ...state, activating: false, activeTaskId: action.data }
    case actionTypes.deactivating: return { ...state, activating: true }
    case actionTypes.deactivated: return { ...state, activating: false, activeTaskId: null }
    case actionTypes.error: return { ...state, ...action.data }

    // conditional updates - update only if active task id matches given id
    case myTasksTypes.closed: return isIdEqual(state, action.data.id) ? { ...state, activeTask: null } : state
    case myTasksTypes.attachmentsUpdated: return isIdEqual(state, action.data.id) ? { ...state, activeTask: { ...state.activeTask, ...action.data } } : state
    case myTasksTypes.updateResultData: return isIdEqual(state, action.data.id) ? { ...state, activeTask: { ...state.activeTask, ...action.data } } : state

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/myActiveTask.js